import { INIT_FAIL, INIT_SUCCESS } from "../actions/dataAnalysis";

const initialState = {
  grade: null,
  class: null,
  number: null,
  name: null,
  listName: null,
  evaluationTerm: [],
  gradeList: [],
  evaluationItems: [],
  selfEvaluations: [],
  otherUserEvaluations: [],
  priorityTargets: []
};

const dataAnalysis = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INIT_SUCCESS:
      return {
        ...state,
        grade: payload.grade,
        class: payload.class,
        number: payload.number,
        name: payload.name,
        listName: payload.listName,
        evaluationTerms: payload.evaluationTerms,
        gradeList: payload.gradeList,
        otherUserEvaluations: payload.otherUserEvaluations,
        evaluationItems: payload.evaluationItems,
        selfEvaluations: payload.selfEvaluations,
        priorityTargets: payload.priorityTargets
      };
    case INIT_FAIL:
      return {
        ...state
      };
    default:
      return {
        ...state
      };
  }
};

export default dataAnalysis;
